import { render, staticRenderFns } from "./UserInactiveForm.vue?vue&type=template&id=d7fa9060"
import script from "./UserInactiveForm.vue?vue&type=script&lang=js"
export * from "./UserInactiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports